import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = {
  class: "filterLine"
};
const _hoisted_2 = {
  class: "filterFieldsFullWidth"
};
const _hoisted_3 = {
  class: "filterItem"
};
const _hoisted_4 = {
  class: "titleFilter"
};
const _hoisted_5 = {
  class: "filterItem"
};
const _hoisted_6 = {
  class: "titleFilter"
};
const _hoisted_7 = {
  class: "filterItem"
};
const _hoisted_8 = {
  class: "titleFilter"
};
const _hoisted_9 = {
  class: "filterExpand"
};
const _hoisted_10 = {
  class: "filterLine"
};
const _hoisted_11 = {
  class: "filterFieldsFullWidth"
};
const _hoisted_12 = {
  class: "filterItem"
};
const _hoisted_13 = {
  class: "titleFilter"
};
const _hoisted_14 = {
  class: "filterItem"
};
const _hoisted_15 = {
  class: "titleFilter"
};
const _hoisted_16 = {
  key: 0,
  class: "filterItem"
};
const _hoisted_17 = {
  class: "titleFilter"
};
const _hoisted_18 = {
  key: 1,
  class: "filterItem"
};
const _hoisted_19 = {
  class: "titleFilter"
};
const _hoisted_20 = {
  key: 2,
  class: "filterItem"
};
const _hoisted_21 = {
  class: "titleFilter"
};
const _hoisted_22 = {
  class: "filterItem"
};
const _hoisted_23 = {
  class: "titleFilter"
};
const _hoisted_24 = {
  class: "filtersRecap"
};
const _hoisted_25 = {
  class: "filterTags"
};
const _hoisted_26 = {
  class: "labelNumberSpeaches"
};
const _hoisted_27 = {
  class: "tableHeader"
};
const _hoisted_28 = {
  class: "speachPictoLine"
};
const _hoisted_29 = {
  class: "tableHeader"
};
const _hoisted_30 = {
  class: "tableHeader"
};
const _hoisted_31 = {
  class: "tableHeader"
};
const _hoisted_32 = {
  class: "columnDate"
};
const _hoisted_33 = {
  key: 0
};
const _hoisted_34 = {
  key: 1
};
const _hoisted_35 = {
  key: 2
};
const _hoisted_36 = ["onClick"];
const _hoisted_37 = ["onClick"];
const _hoisted_38 = {
  key: 0,
  class: "loadingContainer"
};
const _hoisted_39 = {
  class: "loadingContainer"
};
const _hoisted_40 = {
  class: "multiselectActions"
};
const _hoisted_41 = {
  class: "multiselectLeftPart"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_icon = _resolveComponent("icon");
  const _component_w_input = _resolveComponent("w-input");
  const _component_w_select_advanced = _resolveComponent("w-select-advanced");
  const _component_w_date_picker_range = _resolveComponent("w-date-picker-range");
  const _component_el_affix = _resolveComponent("el-affix");
  const _component_w_tag = _resolveComponent("w-tag");
  const _component_el_empty = _resolveComponent("el-empty");
  const _component_el_table_column = _resolveComponent("el-table-column");
  const _component_w_tool_tip = _resolveComponent("w-tool-tip");
  const _component_speach_cell = _resolveComponent("speach-cell");
  const _component_user_cell = _resolveComponent("user-cell");
  const _component_w_date = _resolveComponent("w-date");
  const _component_loader = _resolveComponent("loader");
  const _component_el_table = _resolveComponent("el-table");
  const _component_speach_details = _resolveComponent("speach-details");
  const _component_side_panel = _resolveComponent("side-panel");
  const _component_infinite_loading = _resolveComponent("infinite-loading");
  const _component_standard_button = _resolveComponent("standard-button");
  const _component_batch_update_speach = _resolveComponent("batch-update-speach");
  const _component_el_scrollbar = _resolveComponent("el-scrollbar");
  const _component_w_dialog = _resolveComponent("w-dialog");
  const _component_confirm_dialog = _resolveComponent("confirm-dialog");
  const _directive_click_outside = _resolveDirective("click-outside");
  return _openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["tableLayout", {
      loaded: _ctx.isLoaded
    }])
  }, [_createVNode(_component_el_affix, {
    offset: 80,
    onChange: _ctx.onFixChange
  }, {
    default: _withCtx(() => [_createElementVNode("div", {
      class: _normalizeClass(["filterBar", _ctx.fixeBar ? 'fix' : ''])
    }, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('admin.dashboard.speaches.search.title.speachTitle')), 1), _createVNode(_component_w_input, {
      modelValue: _ctx.filterByTitle,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _ctx.filterByTitle = $event),
      placeholder: _ctx.$t('admin.dashboard.speaches.search.placeholder.speachTitle'),
      clearable: "",
      onInput: _cache[1] || (_cache[1] = $event => _ctx.debouncedSearch()),
      "data-test": "speach-management-search-title"
    }, {
      prefix: _withCtx(() => [_createVNode(_component_icon, {
        icon: "magnify",
        class: "iconMagnify"
      })]),
      _: 1
    }, 8, ["modelValue", "placeholder"])]), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t('admin.dashboard.speaches.search.title.author')), 1), _createVNode(_component_w_input, {
      modelValue: _ctx.filterByAuthor,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _ctx.filterByAuthor = $event),
      placeholder: _ctx.$t('admin.dashboard.speaches.search.placeholder.author'),
      clearable: "",
      onInput: _cache[3] || (_cache[3] = $event => _ctx.debouncedSearch())
    }, {
      prefix: _withCtx(() => [_createVNode(_component_icon, {
        icon: "magnify",
        class: "iconMagnify"
      })]),
      _: 1
    }, 8, ["modelValue", "placeholder"])]), _createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t('admin.dashboard.speaches.search.title.state')), 1), _createVNode(_component_w_select_advanced, {
      "value-key": "id",
      options: _ctx.availableStates,
      placeholder: _ctx.$t('admin.dashboard.speaches.search.title.state'),
      onChange: _ctx.changeSelectedState,
      value: _ctx.filterByState,
      "collapse-tags": true,
      "label-key": "name",
      "data-test": "speach-state-selection"
    }, null, 8, ["options", "placeholder", "onChange", "value"])])]), _createElementVNode("div", _hoisted_9, [_cache[21] || (_cache[21] = _createElementVNode("div", {
      class: "titleFilter"
    }, " ", -1)), !_ctx.filterIsExpanded ? (_openBlock(), _createBlock(_component_icon, {
      key: 0,
      icon: "filter-variant-plus",
      class: "iconExpand",
      onClick: _cache[4] || (_cache[4] = $event => _ctx.filterIsExpanded = !_ctx.filterIsExpanded)
    })) : (_openBlock(), _createBlock(_component_icon, {
      key: 1,
      icon: "filter-variant-minus",
      class: "iconExpand",
      onClick: _cache[5] || (_cache[5] = $event => _ctx.filterIsExpanded = !_ctx.filterIsExpanded)
    }))])]), _createVNode(_Transition, {
      name: "expand"
    }, {
      default: _withCtx(() => [_withDirectives(_createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.$t('admin.dashboard.speaches.search.title.visibility')), 1), _createVNode(_component_w_select_advanced, {
        "value-key": "id",
        options: _ctx.availableVisibilities,
        "option-all": true,
        placeholder: _ctx.$t('admin.dashboard.speaches.search.placeholder.visibility'),
        onChange: _ctx.changeSelectedVisibilities,
        value: _ctx.filterByVisibilities,
        multiple: true,
        "collapse-tags": true,
        "label-key": "name"
      }, null, 8, ["options", "placeholder", "onChange", "value"])]), _createElementVNode("div", _hoisted_14, [_createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.$t('admin.dashboard.speaches.search.title.category')), 1), _createVNode(_component_w_select_advanced, {
        "value-key": "id",
        options: _ctx.availableCategories,
        "option-all": true,
        placeholder: _ctx.$t('admin.dashboard.speaches.search.placeholder.category'),
        onChange: _ctx.changeSelectedCategories,
        value: _ctx.filterByCategories,
        multiple: true,
        "collapse-tags": true,
        "label-key": "name"
      }, null, 8, ["options", "placeholder", "onChange", "value"])]), _ctx.workflowEnabled ? (_openBlock(), _createElementBlock("div", _hoisted_16, [_createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.$t('admin.dashboard.speaches.search.placeholder.inWorkflow')), 1), _createVNode(_component_w_select_advanced, {
        "value-key": "value",
        options: _ctx.availableWorkflowStatus,
        "option-all": true,
        placeholder: _ctx.$t('admin.dashboard.speaches.search.placeholder.inWorkflow'),
        onChange: _ctx.changeWorkflowStatus,
        value: _ctx.workflowStatusCurrentValue,
        "collapse-tags": true,
        "label-key": "name"
      }, null, 8, ["options", "placeholder", "onChange", "value"])])) : _createCommentVNode("", true), _ctx.pinnedEnabled ? (_openBlock(), _createElementBlock("div", _hoisted_18, [_createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.$t('admin.dashboard.speaches.search.placeholder.pinnedOnHome')), 1), _createVNode(_component_w_select_advanced, {
        "value-key": "value",
        options: _ctx.availablePinnedOnHomeStatus,
        "option-all": true,
        placeholder: _ctx.$t('admin.dashboard.speaches.search.placeholder.pinnedOnHome'),
        onChange: _ctx.changePinnedOnHomeStatus,
        value: _ctx.pinnedOnHomeCurrentValue,
        "collapse-tags": true,
        "label-key": "name"
      }, null, 8, ["options", "placeholder", "onChange", "value"])])) : _createCommentVNode("", true), _ctx.periodicReviewEnabled ? (_openBlock(), _createElementBlock("div", _hoisted_20, [_createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.$t('admin.dashboard.speaches.search.placeholder.periodicReview')), 1), _createVNode(_component_w_select_advanced, {
        "value-key": "value",
        options: _ctx.availablePeriodicReviewStatus,
        "option-all": true,
        placeholder: _ctx.$t('admin.dashboard.speaches.search.placeholder.periodicReview'),
        onChange: _ctx.changePeriodicReviewStatus,
        value: _ctx.periodicReviewCurrentValue,
        "collapse-tags": true,
        "label-key": "name"
      }, null, 8, ["options", "placeholder", "onChange", "value"])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_22, [_createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.$t('admin.dashboard.speaches.search.placeholder.date')), 1), _createVNode(_component_w_date_picker_range, {
        "calendar-range": _ctx.calendarRange,
        onChangeCalendarRange: _ctx.changeCalendarRange,
        separator: "-",
        placement: "bottom-end"
      }, null, 8, ["calendar-range", "onChangeCalendarRange"])])]), _cache[22] || (_cache[22] = _createElementVNode("div", {
        class: "filterExpand"
      }, null, -1))], 512), [[_vShow, _ctx.filterIsExpanded]])]),
      _: 1
    })], 2)]),
    _: 1
  }, 8, ["onChange"]), _withDirectives(_createElementVNode("div", _hoisted_24, [_createElementVNode("div", _hoisted_25, [_ctx.filterByTitle ? (_openBlock(), _createBlock(_component_w_tag, {
    key: 0,
    "text-tag": _ctx.filterByTitle,
    round: "",
    closable: true,
    onRemoveTag: _ctx.clearFilterByTitle
  }, null, 8, ["text-tag", "onRemoveTag"])) : _createCommentVNode("", true), _ctx.filterByAuthor ? (_openBlock(), _createBlock(_component_w_tag, {
    key: 1,
    "text-tag": _ctx.filterByAuthor,
    round: "",
    closable: true,
    onRemoveTag: _ctx.clearFilterByAuthor
  }, null, 8, ["text-tag", "onRemoveTag"])) : _createCommentVNode("", true), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filterByVisibilities, visibility => {
    return _openBlock(), _createBlock(_component_w_tag, {
      key: visibility + 'visibilityTag',
      "text-tag": _ctx.$t('admin.dashboard.speaches.filterChip.visibility', {
        visibility: _ctx.visibilityTag(visibility)
      }),
      round: "",
      closable: true,
      onRemoveTag: $event => _ctx.clearFilterByVisibility(visibility)
    }, null, 8, ["text-tag", "onRemoveTag"]);
  }), 128)), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filterByCategories, category => {
    return _openBlock(), _createBlock(_component_w_tag, {
      key: category + 'categoryTag',
      "text-tag": _ctx.$t('admin.dashboard.speaches.filterChip.category', {
        category: _ctx.categoryName(category)
      }),
      round: "",
      closable: true,
      onRemoveTag: $event => _ctx.clearFilterByCategory(category)
    }, null, 8, ["text-tag", "onRemoveTag"]);
  }), 128)), _ctx.filterInWorkflow !== null ? (_openBlock(), _createBlock(_component_w_tag, {
    key: 2,
    "text-tag": _ctx.filterInWorkflow ? _ctx.$t('admin.dashboard.speaches.workflowState.inWorkflow') : _ctx.$t('admin.dashboard.speaches.workflowState.notInWorkflow'),
    round: "",
    closable: true,
    onRemoveTag: _cache[6] || (_cache[6] = $event => _ctx.clearFilterByWorkflowState())
  }, null, 8, ["text-tag"])) : _createCommentVNode("", true), _ctx.filterPinnedOnHome !== null ? (_openBlock(), _createBlock(_component_w_tag, {
    key: 3,
    "text-tag": _ctx.filterPinnedOnHome ? _ctx.$t('admin.dashboard.speaches.pinnedOnHomeState.pinnedOnHome') : _ctx.$t('admin.dashboard.speaches.pinnedOnHomeState.notPinnedOnHome'),
    round: "",
    closable: true,
    onRemoveTag: _cache[7] || (_cache[7] = $event => _ctx.clearFilterByPinnedOnHome())
  }, null, 8, ["text-tag"])) : _createCommentVNode("", true), _ctx.filterPeriodicReview !== null ? (_openBlock(), _createBlock(_component_w_tag, {
    key: 4,
    "text-tag": _ctx.filterPeriodicReview ? _ctx.$t('admin.dashboard.speaches.periodicReviewState.hasPeriodicReview') : _ctx.$t('admin.dashboard.speaches.periodicReviewState.noPeriodicReview'),
    round: "",
    closable: true,
    onRemoveTag: _cache[8] || (_cache[8] = $event => _ctx.clearFilterByPeriodicReview())
  }, null, 8, ["text-tag"])) : _createCommentVNode("", true), _ctx.calendarRange && _ctx.calendarRange[0] ? (_openBlock(), _createBlock(_component_w_tag, {
    key: 5,
    "text-tag": _ctx.$t('admin.dashboard.speaches.filterChip.date', {
      start: _ctx.$d(_ctx.calendarRange[0]),
      end: _ctx.$d(_ctx.calendarRange[1])
    }),
    round: "",
    closable: true,
    onRemoveTag: _ctx.clearFilterByCalendarRange
  }, null, 8, ["text-tag", "onRemoveTag"])) : _createCommentVNode("", true)]), _createElementVNode("div", {
    class: "labelClearFilters",
    onClick: _cache[9] || (_cache[9] =
    //@ts-ignore
    (...args) => _ctx.clearAllFilters && _ctx.clearAllFilters(...args))
  }, _toDisplayString(_ctx.$t('admin.dashboard.users.clearFilters')), 1)], 512), [[_vShow, _ctx.filterByTitle !== '' || _ctx.filterByAuthor !== '' || _ctx.filterByCategories.length > 0 || _ctx.filterByVisibilities.length > 0 || _ctx.filterInWorkflow !== null || _ctx.filterPinnedOnHome !== null || _ctx.filterPeriodicReview !== null || _ctx.calendarRange && _ctx.calendarRange.length > 0 && _ctx.calendarRange[0]]]), _createElementVNode("div", _hoisted_26, _toDisplayString(
  // noinspection TypeScriptValidateTypes: We can totally add parameters to the $t method, for parameterized translations (and it works)
  _ctx.$t('admin.dashboard.speaches.nbSpeaches', {
    count: _ctx.totalSpeaches,
    total: _ctx.totalSpeaches
  })), 1), _withDirectives(_createVNode(_component_el_empty, {
    class: "emptyPanel",
    description: _ctx.$t('admin.dashboard.speaches.noResult')
  }, null, 8, ["description"]), [[_vShow, _ctx.isEmptyResult && _ctx.emptyState]]), _createElementVNode("div", {
    id: "TableSpeaches",
    class: _normalizeClass(!_ctx.infiniteLoadingEnd ? 'tableSpeachesPadding' : '')
  }, [_ctx.listSpeaches.length > 0 ? (_openBlock(), _createBlock(_component_el_table, {
    key: 0,
    class: "tableCustom",
    "table-layout": "auto",
    ref: "tableRef",
    "show-overflow-tooltip": true,
    data: _ctx.listSpeaches,
    "tooltip-effect": "light",
    "row-class-name": _ctx.filterByState !== _ctx.SpeachState.ARCHIVE ? 'speachManagementClickableRow' : '',
    onSelectionChange: _ctx.handleSpeachesSelectionChange,
    onRowClick: _ctx.selectSpeach
  }, {
    default: _withCtx(() => [_createVNode(_component_el_table_column, {
      type: "selection",
      width: "55"
    }), _createVNode(_component_el_table_column, {
      width: "500"
    }, {
      header: _withCtx(() => [_createElementVNode("div", _hoisted_27, _toDisplayString(_ctx.$t('admin.dashboard.speaches.search.title.speachTitle')), 1)]),
      default: _withCtx(speach => [_createVNode(_component_speach_cell, {
        speach: speach.row,
        "search-term": _ctx.filterByTitle,
        "second-line-content": speach.row.visibility,
        class: "speachCell",
        "data-test": 'speach-edit-' + speach.$index
      }, {
        secondLine: _withCtx(() => [_createElementVNode("div", _hoisted_28, [speach.row.isPinnedOnHome ? (_openBlock(), _createBlock(_component_w_tool_tip, {
          key: 0,
          text: _ctx.$t('admin.dashboard.speaches.search.placeholder.pinnedOnHome')
        }, {
          default: _withCtx(() => [_createVNode(_component_icon, {
            icon: "pin-outline"
          })]),
          _: 1
        }, 8, ["text"])) : _createCommentVNode("", true), _createVNode(_component_w_tool_tip, {
          text: _ctx.$t('admin.dashboard.speaches.filterChip.visibility', {
            visibility: _ctx.visibilityTag(speach.row.visibility)
          })
        }, {
          default: _withCtx(() => [speach.row.visibility === _ctx.VisibilityEnum.PRIVE ? (_openBlock(), _createBlock(_component_icon, {
            key: 0,
            icon: "link-lock"
          })) : speach.row.visibility === _ctx.VisibilityEnum.SEMI_PRIVE ? (_openBlock(), _createBlock(_component_icon, {
            key: 1,
            icon: "link"
          })) : speach.row.visibility === _ctx.VisibilityEnum.RESTREINT ? (_openBlock(), _createBlock(_component_icon, {
            key: 2,
            icon: "lock-outline"
          })) : (_openBlock(), _createBlock(_component_icon, {
            key: 3,
            icon: "earth"
          }))]),
          _: 2
        }, 1032, ["text"]), _ctx.periodicReviewEnabled && speach.row.speachMetadata && speach.row.speachMetadata.nextPeriodicReviewTimestamp ? (_openBlock(), _createBlock(_component_w_tool_tip, {
          key: 1,
          text: _ctx.$t('admin.dashboard.speaches.periodicReview.tooltip', {
            nextDate: _ctx.getNextPeriodicReviewDateFormatted(speach.row)
          })
        }, {
          default: _withCtx(() => [_createVNode(_component_icon, {
            class: _normalizeClass(_ctx.isNewPeriodicReviewNeeded(speach.row) ? 'periodicChipUrgent' : ''),
            icon: "clock-end"
          }, null, 8, ["class"])]),
          _: 2
        }, 1032, ["text"])) : _createCommentVNode("", true), speach.row.isWorkflowInProgress || speach.row.regulated_gmp && speach.row.wf_name ? (_openBlock(), _createBlock(_component_w_tag, {
          key: 2,
          class: "tableChip workflowChip",
          "with-tool-tip": false,
          ellipsis: true,
          "text-tag": speach.row.wf_name,
          round: "",
          closable: false
        }, null, 8, ["text-tag"])) : _createCommentVNode("", true)])]),
        _: 2
      }, 1032, ["speach", "search-term", "second-line-content", "data-test"])]),
      _: 1
    }), _createVNode(_component_el_table_column, null, {
      header: _withCtx(() => [_createElementVNode("div", _hoisted_29, _toDisplayString(_ctx.$t('admin.dashboard.speaches.search.title.author')), 1)]),
      default: _withCtx(speach => [_createVNode(_component_user_cell, {
        user: _ctx.getSpeachAuthor(speach.row),
        "search-term": _ctx.filterByAuthor,
        "second-line-content": _ctx.getSpeachAuthor(speach.row).email,
        class: "userCell"
      }, null, 8, ["user", "search-term", "second-line-content"])]),
      _: 1
    }), _createVNode(_component_el_table_column, null, {
      header: _withCtx(() => [_createElementVNode("div", _hoisted_30, _toDisplayString(_ctx.$t('admin.dashboard.speaches.search.title.category')), 1)]),
      default: _withCtx(speach => [speach.row.category !== undefined ? (_openBlock(), _createBlock(_component_w_tag, {
        key: 0,
        class: "tableChip",
        ellipsis: true,
        "text-tag": speach.row.category.name,
        round: "",
        closable: false
      }, null, 8, ["text-tag"])) : _createCommentVNode("", true)]),
      _: 1
    }), _createVNode(_component_el_table_column, {
      width: "150"
    }, {
      header: _withCtx(() => [_createElementVNode("div", _hoisted_31, _toDisplayString(_ctx.$t('admin.dashboard.speaches.search.title.date')), 1)]),
      default: _withCtx(speach => [_createElementVNode("div", _hoisted_32, [_ctx.filterByState === 'PUBLIE' ? (_openBlock(), _createElementBlock("div", _hoisted_33, _toDisplayString(_ctx.$t('admin.dashboard.speaches.state.date.published')), 1)) : _ctx.filterByState === 'ARCHIVE' ? (_openBlock(), _createElementBlock("div", _hoisted_34, _toDisplayString(_ctx.$t('admin.dashboard.speaches.state.date.archived')), 1)) : (_openBlock(), _createElementBlock("div", _hoisted_35, _toDisplayString(_ctx.$t('admin.dashboard.speaches.state.date.notPublished')), 1)), speach.row.hasPendingUpdates ? (_openBlock(), _createBlock(_component_w_tool_tip, {
        key: 3,
        text: _ctx.$t('admin.dashboard.speaches.state.tooltip.lastEdit', {
          date: _ctx.$d(speach.row.lastUpdatedTimestamp)
        })
      }, {
        default: _withCtx(() => [_createVNode(_component_icon, {
          icon: "alert-outline",
          class: "dateAlert"
        })]),
        _: 2
      }, 1032, ["text"])) : _createCommentVNode("", true), _ctx.isDelayed(speach.row) ? (_openBlock(), _createBlock(_component_w_tool_tip, {
        key: 4,
        text: _ctx.$t('admin.dashboard.speaches.state.tooltip.delayed', {
          date: _ctx.$d(speach.row.delayedTillTimestamp || speach.row.futureVersionDelayedTillTimestamp)
        })
      }, {
        default: _withCtx(() => [_createVNode(_component_icon, {
          icon: "calendar-clock-outline",
          class: "delayAlert"
        })]),
        _: 2
      }, 1032, ["text"])) : _createCommentVNode("", true)]), _createVNode(_component_w_date, {
        class: "tableCell",
        "string-date": _ctx.getPublicationOrUpdatedDate(speach.row)
      }, null, 8, ["string-date"])]),
      _: 1
    }), _createVNode(_component_el_table_column, {
      width: "50"
    }, {
      default: _withCtx(speach => [_ctx.filterByState !== _ctx.SpeachState.ARCHIVE ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "clickableCell",
        onClick: $event => _ctx.selectSpeach(speach.row)
      }, [_createVNode(_component_w_tool_tip, {
        text: _ctx.$t('admin.dashboard.users.table.infoTooltip')
      }, {
        default: _withCtx(() => [_createVNode(_component_icon, {
          class: "clickableIcon",
          icon: "pencil-outline"
        })]),
        _: 1
      }, 8, ["text"])], 8, _hoisted_36)) : (_openBlock(), _createElementBlock("div", {
        key: 1,
        class: "clickableCell",
        onClick: $event => _ctx.restoreSpeach(speach.row)
      }, [_createVNode(_component_w_tool_tip, {
        text: _ctx.$t('admin.dashboard.speaches.multiselect.restore')
      }, {
        default: _withCtx(() => [_createVNode(_component_icon, {
          class: "clickableIcon",
          icon: "file-undo-outline"
        })]),
        _: 1
      }, 8, ["text"])], 8, _hoisted_37))]),
      _: 1
    }), _ctx.busyInfiniteLoading ? (_openBlock(), _createElementBlock("div", _hoisted_38, [_createVNode(_component_loader)])) : _createCommentVNode("", true)]),
    _: 1
  }, 8, ["data", "row-class-name", "onSelectionChange", "onRowClick"])) : _createCommentVNode("", true)], 2), _withDirectives((_openBlock(), _createBlock(_component_side_panel, {
    visible: _ctx.sidePanelVisible,
    class: "sidePanelContainer sidepanel-click-filter",
    "close-button-visible": true,
    "wide-side-panel": true,
    onClose: _ctx.closeSidePanel
  }, {
    default: _withCtx(() => [_ctx.selectedSpeach !== null ? (_openBlock(), _createBlock(_component_speach_details, {
      key: 0,
      visible: _ctx.sidePanelVisible,
      onReinitSearch: _ctx.reinitSearch,
      speach: _ctx.selectedSpeach,
      "workflow-enabled": _ctx.workflowEnabled,
      "scorm-classic-enabled": _ctx.scormClassicEnabled,
      "class-click-filter": "sidepanel-click-filter"
    }, null, 8, ["visible", "onReinitSearch", "speach", "workflow-enabled", "scorm-classic-enabled"])) : _createCommentVNode("", true)]),
    _: 1
  }, 8, ["visible", "onClose"])), [[_directive_click_outside, _ctx.closeSidePanel]]), _ctx.isLoaded ? (_openBlock(), _createBlock(_component_infinite_loading, {
    key: 0,
    identifier: _ctx.gridID,
    distance: 200,
    onInfinite: _ctx.debounceInfinite
  }, {
    "no-more": _withCtx(() => _cache[23] || (_cache[23] = [_createElementVNode("div", null, null, -1)])),
    "no-results": _withCtx(() => _cache[24] || (_cache[24] = [_createElementVNode("div", null, null, -1)])),
    spinner: _withCtx(() => [_createElementVNode("div", _hoisted_39, [_createVNode(_component_loader)])]),
    _: 1
  }, 8, ["identifier", "onInfinite"])) : _createCommentVNode("", true), _ctx.multiselectSpeaches.length > 0 ? (_openBlock(), _createBlock(_component_el_affix, {
    key: 1,
    position: "bottom",
    target: "#TableSpeaches",
    offset: 0
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_40, [_createElementVNode("div", _hoisted_41, [_createTextVNode(_toDisplayString(
    // noinspection TypeScriptValidateTypes: We can totally add parameters to the $t method, for parameterized translations (and it works)
    _ctx.$t('admin.dashboard.speaches.speachesSelected', {
      count: _ctx.multiselectSpeaches.length
    })) + " ", 1), _ctx.multiselectSpeaches.length === 1 && _ctx.filterByState !== _ctx.SpeachState.ARCHIVE ? (_openBlock(), _createBlock(_component_w_tool_tip, {
      key: 0,
      text: _ctx.$t('admin.dashboard.speaches.multiselect.view')
    }, {
      default: _withCtx(() => [_createVNode(_component_icon, {
        class: "clickableIcon",
        icon: "eye-outline",
        onClick: _cache[10] || (_cache[10] = $event => _ctx.goToSpeach(_ctx.multiselectSpeaches[0]))
      })]),
      _: 1
    }, 8, ["text"])) : _createCommentVNode("", true), _ctx.multiselectSpeaches.length > 1 && _ctx.filterByState !== _ctx.SpeachState.ARCHIVE ? (_openBlock(), _createBlock(_component_w_tool_tip, {
      key: 1,
      text: _ctx.$t('admin.dashboard.speaches.multiselect.batchEdit')
    }, {
      default: _withCtx(() => [_createVNode(_component_icon, {
        class: "clickableIcon",
        icon: "text-box-edit-outline",
        onClick: _cache[11] || (_cache[11] = $event => _ctx.editInfosPopup = true)
      })]),
      _: 1
    }, 8, ["text"])) : _createCommentVNode("", true), _ctx.multiselectSpeaches.length === 1 && _ctx.filterByState !== _ctx.SpeachState.ARCHIVE ? (_openBlock(), _createBlock(_component_w_tool_tip, {
      key: 2,
      text: _ctx.$t('admin.dashboard.speaches.multiselect.edit')
    }, {
      default: _withCtx(() => [_createVNode(_component_icon, {
        class: "clickableIcon",
        icon: "pencil-outline",
        onClick: _cache[12] || (_cache[12] = $event => _ctx.goToSpeachEdition(_ctx.multiselectSpeaches[0]))
      })]),
      _: 1
    }, 8, ["text"])) : _createCommentVNode("", true), _ctx.multiselectSpeaches.length === 1 && (_ctx.multiselectSpeaches[0].state !== _ctx.SpeachState.NON_PUBLIE || _ctx.isDelayed(_ctx.multiselectSpeaches[0])) && _ctx.filterByState !== _ctx.SpeachState.ARCHIVE ? (_openBlock(), _createBlock(_component_w_tool_tip, {
      key: 3,
      text: _ctx.$t('admin.dashboard.speaches.multiselect.share')
    }, {
      default: _withCtx(() => [_createVNode(_component_icon, {
        class: "clickableIcon",
        icon: "share-outline",
        onClick: _cache[13] || (_cache[13] = $event => _ctx.shareSpeach(_ctx.multiselectSpeaches[0]))
      })]),
      _: 1
    }, 8, ["text"])) : _createCommentVNode("", true), _ctx.multiselectSpeaches.length === 1 && _ctx.multiselectSpeaches[0].state !== _ctx.SpeachState.NON_PUBLIE && _ctx.filterByState !== _ctx.SpeachState.ARCHIVE ? (_openBlock(), _createBlock(_component_w_tool_tip, {
      key: 4,
      text: _ctx.$t('admin.dashboard.speaches.multiselect.analytics')
    }, {
      default: _withCtx(() => [_createVNode(_component_icon, {
        class: "clickableIcon",
        icon: "chart-bar",
        onClick: _cache[14] || (_cache[14] = $event => _ctx.goToMonitorSpeach(_ctx.multiselectSpeaches[0]))
      })]),
      _: 1
    }, 8, ["text"])) : _createCommentVNode("", true), _ctx.multiselectSpeaches.length === 1 && _ctx.filterByState !== _ctx.SpeachState.ARCHIVE ? (_openBlock(), _createBlock(_component_w_tool_tip, {
      key: 5,
      text: _ctx.$t('admin.dashboard.speaches.multiselect.duplicate')
    }, {
      default: _withCtx(() => [_createVNode(_component_icon, {
        class: "clickableIcon",
        icon: "content-copy",
        onClick: _cache[15] || (_cache[15] = $event => _ctx.duplicateSpeach(_ctx.multiselectSpeaches[0]))
      })]),
      _: 1
    }, 8, ["text"])) : _createCommentVNode("", true), _ctx.multiselectSpeaches.length === 1 && _ctx.filterByState !== _ctx.SpeachState.ARCHIVE ? (_openBlock(), _createBlock(_component_w_tool_tip, {
      key: 6,
      text: _ctx.$t('admin.dashboard.speaches.multiselect.template')
    }, {
      default: _withCtx(() => [_createVNode(_component_icon, {
        class: "clickableIcon",
        icon: "clipboard-multiple-outline",
        onClick: _cache[16] || (_cache[16] = $event => _ctx.createTemplate(_ctx.multiselectSpeaches[0]))
      })]),
      _: 1
    }, 8, ["text"])) : _createCommentVNode("", true), _ctx.multiselectSpeaches.length === 1 && _ctx.multiselectSpeaches[0].state !== _ctx.SpeachState.NON_PUBLIE && _ctx.filterByState !== _ctx.SpeachState.ARCHIVE ? (_openBlock(), _createBlock(_component_w_tool_tip, {
      key: 7,
      text: _ctx.$t('admin.dashboard.speaches.multiselect.scorm')
    }, {
      default: _withCtx(() => [_createVNode(_component_icon, {
        class: "clickableIcon",
        icon: "download-outline",
        onClick: _cache[17] || (_cache[17] = $event => _ctx.triggerScormExportDialog())
      })]),
      _: 1
    }, 8, ["text"])) : _createCommentVNode("", true), _ctx.filterByState !== _ctx.SpeachState.ARCHIVE ? (_openBlock(), _createBlock(_component_w_tool_tip, {
      key: 8,
      text: _ctx.$t('admin.dashboard.speaches.multiselect.archive')
    }, {
      default: _withCtx(() => [_createVNode(_component_icon, {
        class: "clickableIcon",
        icon: "delete-outline",
        onClick: _ctx.archiveListSpeaches
      }, null, 8, ["onClick"])]),
      _: 1
    }, 8, ["text"])) : _createCommentVNode("", true), _ctx.filterByState === _ctx.SpeachState.ARCHIVE ? (_openBlock(), _createBlock(_component_w_tool_tip, {
      key: 9,
      text: _ctx.$t('admin.dashboard.speaches.multiselect.restore')
    }, {
      default: _withCtx(() => [_createVNode(_component_icon, {
        class: "clickableIcon",
        icon: "file-undo-outline",
        onClick: _ctx.restoreListSpeaches
      }, null, 8, ["onClick"])]),
      _: 1
    }, 8, ["text"])) : _createCommentVNode("", true)]), _createVNode(_component_standard_button, {
      outlined: true,
      label: _ctx.$t('admin.dashboard.users.sidebar.deactivation.cancel'),
      onClick: _ctx.deselectAllUser
    }, null, 8, ["label", "onClick"])])]),
    _: 1
  })) : _createCommentVNode("", true), _createVNode(_component_w_dialog, {
    visible: _ctx.editInfosPopup,
    onOnDialogClose: _cache[18] || (_cache[18] = $event => _ctx.editInfosPopup = false),
    title: _ctx.$t('admin.dashboard.speaches.batchEdit', {
      count: _ctx.multiselectSpeaches.length
    })
  }, {
    default: _withCtx(() => [_createVNode(_component_el_scrollbar, null, {
      default: _withCtx(() => [_createVNode(_component_batch_update_speach, {
        "speaches-to-update": _ctx.multiselectSpeaches,
        onBatchUpdateSuccess: _ctx.batchEditSpeaches,
        onBatchUpdateCancel: _ctx.closeBatchEdit
      }, null, 8, ["speaches-to-update", "onBatchUpdateSuccess", "onBatchUpdateCancel"])]),
      _: 1
    })]),
    _: 1
  }, 8, ["visible", "title"]), _createVNode(_component_confirm_dialog, {
    title: _ctx.$t('admin.dashboard.speaches.templates.popup.title'),
    message: _ctx.$t('admin.dashboard.speaches.templates.popup.message'),
    "confirm-button-text": _ctx.$t('admin.dashboard.speaches.templates.popup.goToTemplates'),
    "cancel-button-text": _ctx.$t('admin.dashboard.speaches.templates.popup.stay'),
    visible: _ctx.goToTemplatesPopup,
    centered: false,
    onOnDialogClose: _cache[19] || (_cache[19] = $event => _ctx.goToTemplatesPopup = false),
    onOnCanceled: _cache[20] || (_cache[20] = $event => _ctx.goToTemplatesPopup = false),
    onOnConfirmed: _ctx.goToTemplates
  }, null, 8, ["title", "message", "confirm-button-text", "cancel-button-text", "visible", "onOnConfirmed"])], 2);
}